import { MagnifyingGlassIcon } from '@radix-ui/react-icons';
import { Button } from '@workos-inc/design-system';
import classNames from 'classnames';
import * as React from 'react';
import { Search } from './search';
export const HeaderInlineSearch = () => {
  const inlineSearchButtonRef = React.useRef<HTMLButtonElement>(null);
  const inlineSearchInputRef = React.useRef<HTMLInputElement>(null);
  const [inlineSearchVisible, setInlineSearchVisible] = React.useState(false);
  React.useEffect(() => {
    const input = inlineSearchInputRef.current;
    const handleResize = () => {
      setInlineSearchVisible(false);
      inlineSearchButtonRef.current?.focus();
    };
    const handleWindowKeyDown = (event: KeyboardEvent) => {
      if (event.key === '/') {
        requestAnimationFrame(() => {
          setInlineSearchVisible(true);
        });
      }
    };
    if (inlineSearchVisible) {
      requestAnimationFrame(() => {
        input?.focus();
        addEventListener('resize', handleResize);
      });
    } else {
      addEventListener('keydown', handleWindowKeyDown);
    }
    return () => {
      removeEventListener('keydown', handleWindowKeyDown);
      removeEventListener('resize', handleResize);
    };
  }, [inlineSearchVisible]);
  return <span className="HeaderInlineSearch" data-sentry-component="HeaderInlineSearch" data-sentry-source-file="header-inline-search.tsx">
      <Button ref={inlineSearchButtonRef} ghost color="gray" size="2" onClick={() => setInlineSearchVisible(current => !current)} data-sentry-element="Button" data-sentry-source-file="header-inline-search.tsx">
        <MagnifyingGlassIcon height="16" style={{
        marginLeft: -2
      }} width="16" data-sentry-element="MagnifyingGlassIcon" data-sentry-source-file="header-inline-search.tsx" />
        Search
      </Button>

      <div className={classNames('HeaderInlineSearchInner')} onAnimationEnd={event => {
      if (event.target === event.currentTarget) {
        setInlineSearchVisible(false);
      }
    }}>
        {inlineSearchVisible && <Search ref={inlineSearchInputRef} onEmptyEscapeKeyDown={() => {
        inlineSearchButtonRef.current?.focus();
      }} />}
      </div>
    </span>;
};